import { Card } from "@coherence-design-system/controls";
import { CardContent } from "@mui/material";
import { useEffect, useState } from "react";
import DisplayAPIsException from "../../../BasicComponents/DisplayAPIsExceptionAlert";
import { logException } from "../../../helper/AppInsightsHelper";
import { IArrayKey } from "../../../interfaces/CarouselProps.interfaces";
import { Loader } from "../../../SharedComponents/Loader";
import { useGetFeaturesDataQuery } from "../../../slices/ExploreCustomers.slice";
import { arrSortDescByKeyLength } from "../../../Utils/js-common";
import { CustomerFeatureChart } from "./CustomerFeatureChart";
import { FeatureDataViewProps } from "./FeatureDataView.types";

export default function FeatureDataView({ selectedFamily, tenantId }: FeatureDataViewProps) {
  const { data, isFetching, error } = useGetFeaturesDataQuery({ id: tenantId, productFamily: selectedFamily });
  const [sortedData, setSortedData] = useState<any[]>([]);

  useEffect(() => {
    if (isFetching) {
      setSortedData([]); // Clear data while fetching
    } else if (error) {
      logException("Customer Page", "Features", "useGetFeaturesDataQuery", error);
      setSortedData([]); // Clear data on API error (500)
    } else if (data) {
      setSortedData(
        arrSortDescByKeyLength({
          key: "data",
          data: JSON.parse(JSON.stringify(data))
        } as IArrayKey)
      );
    }
  }, [data, isFetching, error]);

  return (
    <>
      {/* Loader while fetching new data */}
      <Loader loading={isFetching} rowProps={undefined} spinnerStack={undefined} />

      {/* Error Handling */}
      {error && <DisplayAPIsException error={error} height={250} />}

      {/* No Data Found */}
      {!isFetching && !error && sortedData.length === 0 && (
        <span style={{ marginLeft: "45%", marginTop: 50, background: "#FFF", lineHeight: 6 }}>
          No Feature Data found for the given Tenant Id
        </span>
      )}

      {/* Render Data */}
      {!isFetching && sortedData.length > 0 && (
        <Card>
          <CardContent>
            <CustomerFeatureChart
              key={selectedFamily}
              carouseldata={{
                name: "",
                items: sortedData.map(({ name: kpiName, data: kpiData, kustoLink: kpiKustoLink }) => ({
                  name: kpiName,
                  data: kpiData,
                  kustoLink: kpiKustoLink || ""
                }))
              }}
            />
          </CardContent>
        </Card>
      )}
    </>
  );
}
